module.exports = __webpack_public_path__ + "static/media/mur.ab4bd7d4.png";